import { ref } from 'vue';
import { useBanking } from './useBanking';
import { useAppState } from './useAppState';
export function useRecurringPaymentsSidebar(registerSidebar = null, handlers) {
    const banking = useBanking();
    const state = useAppState();
    const recurringPayments = ref([]);
    const selectedRecurringPaymentId = ref(null);
    function fetchAndRegisterRecurringPayments() {
        banking.getBankingInfo(() => {
            banking.getRecurringPayments((res) => {
                recurringPayments.value = res.payments || [];
                registerRecurringPaymentsSidebar();
            });
        });
    }
    function registerRecurringPaymentsSidebar() {
        if (!registerSidebar)
            return;
        const items = recurringPayments.value.map((rp) => {
            const account = state.bankInfo?.accounts?.find((a) => a.id === rp.bankAccountId);
            const accountLabel = account ? `${account.bankDisplayName} · ${account.displayName}` : null;
            return {
                id: rp.merchantName,
                title: rp.merchant ? rp.merchant.name : rp.merchantName,
                subtitle: accountLabel || null,
                meta: `£${Math.abs(rp.lastAmount).toFixed(2)}`,
                meta2: `Day ${rp.avgPaymentDay}`,
                statusChip: rp.increasing
                    ? { label: 'increasing', color: 'red', icon: 'mdi-arrow-up', variant: 'tonal' }
                    : rp.changing
                        ? { label: 'decreasing', color: 'green', icon: 'mdi-arrow-down', variant: 'tonal' }
                        : { label: 'stable', color: 'green', icon: 'mdi-check', variant: 'outlined' }
            };
        });
        registerSidebar({
            config: {
                actionButton: null,
                pageItemsTitle: 'Recurring Payments',
                pageItems: items,
                currentPageItemId: selectedRecurringPaymentId.value
            },
            handlers: {
                onActionClick: () => { },
                onPageItemClick: (id) => { filterByRecurringPayment(id); },
                onPageItemDelete: () => { },
                onPageItemRename: () => { },
                onOpenSettings: () => { if (handlers?.onOpenSettings)
                    handlers.onOpenSettings(); }
            }
        });
    }
    function filterByRecurringPayment(merchantName) {
        selectedRecurringPaymentId.value = merchantName;
        if (handlers?.onFilterChange)
            handlers.onFilterChange(merchantName);
        registerRecurringPaymentsSidebar();
    }
    function clearRecurringPaymentFilter() {
        selectedRecurringPaymentId.value = null;
        if (handlers?.onFilterChange)
            handlers.onFilterChange(null);
        registerRecurringPaymentsSidebar();
    }
    return {
        recurringPayments,
        selectedRecurringPaymentId,
        fetchAndRegisterRecurringPayments,
        registerRecurringPaymentsSidebar,
        filterByRecurringPayment,
        clearRecurringPaymentFilter,
    };
}
